import { API } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-path/v1/api.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaV1Service = bindHTTP(API);
